export default "__VITE_ASSET__KFI2_AOM__"